import React from "react"
import { useQuery } from "@tanstack/react-query"
import api from "../services/api"
import { useDashboardFilters } from "../state/dashboardFilters"
import WorkoutTable from "../components/WorkoutTable"
import WorkoutChart from "../components/WorkoutChart"
import AdditionalInsights from "../components/AdditionalInsights"

export default function WorkoutsPage() {
  const { adminOnly, autoRefresh } = useDashboardFilters()

  const { data: stats, isLoading: statsLoading } = useQuery({
    queryKey: ["stats", adminOnly],
    queryFn: () => api.getStats(adminOnly),
    refetchInterval: autoRefresh ? 30000 : false,
  })

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Workouts</h1>
        <p className="text-muted-foreground">
          View and manage workout sessions, analyze trends and patterns.
        </p>
      </div>

      {/* Charts Grid */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <WorkoutChart data={stats?.dailyWorkouts} isLoading={statsLoading} />
        <AdditionalInsights adminOnly={adminOnly} />
      </div>

      {/* Workout Table */}
      <WorkoutTable adminOnly={adminOnly} />
    </div>
  )
}
